import type { CatalogTree } from '../types';

export const sales = {
  tabs: {
    label: 'Satış bölümleri',
    opportunities: 'Fırsatlar',
    sales: 'Satışlar',
    summary: 'Özet',
  },
  filters: {
    all: 'Tümü',
    channel: 'Kanal',
    assignee: 'Atanan',
    me: 'Bana atananlar',
    unassigned: 'Atanmamış',
    search: 'Ara',
    label: 'Etiket',
    method: 'Yöntem',
    status: 'Durum',
  },
  opportunities: {
    table: 'Fırsatlar',
    empty: 'Açık fırsat yok.',
    columns: {
      shopper: 'Müşteri',
      status: 'Durum',
      orderDetails: 'Sipariş',
      products: 'Ürünler',
      lastActivity: 'Son etkinlik',
      assignee: 'Atanan',
    },
    orderDetails: 'Sipariş bilgileri alındı',
    unassigned: 'Atanmamış',
    sold: 'Satıldı',
    lost: 'Kaybedildi',
    openConversation: 'Konuşmayı aç',
  },
  sales: {
    table: 'Satışlar',
    empty: 'Bu dönemde satış yok.',
    columns: {
      date: 'Tarih',
      shopper: 'Müşteri',
      channel: 'Kanal',
      source: 'Kaynak',
      amount: 'Tutar',
      method: 'Yöntem',
      label: 'Etiket',
      status: 'Durum',
      conversation: 'Konuşma',
    },
    order: 'Sipariş #{number}',
    staffSale: 'Personel kaydı',
    openConversation: 'Konuşmayı aç',
    method: {
      link: 'Bağlantı',
      identity: 'Kimlik eşleşmesi',
      staff: 'Personel',
    },
    rule: {
      link_param: 'Sipariş bağlantı kodunu taşıyor',
      identity_product: 'Telefon veya e-posta eşleşti ve ürün konuşuldu',
      staff_sale: 'Personel kaydıyla birleşti',
      identity_only: 'Yalnızca telefon veya e-posta eşleşti',
      link_open: 'Bağlantı açıldı',
    },
    status: {
      active: 'Aktif',
      reversed: 'Geri alındı',
      rejected: 'Reddedildi',
    },
    reversal: {
      cancelled: 'Geri alındı: iptal',
      refunded: 'Geri alındı: iade',
      staff: 'Geri alındı: personel',
    },
    confirm: 'Onayla',
    reject: 'Reddet',
    relink: 'Yeniden bağla',
    rejectDialog: {
      title: 'Eşleşme reddedilsin mi?',
      description: 'Bu sipariş bu konuşmaya bir daha bağlanmaz; başka bir konuşmaya bağlanabilir.',
    },
    relinkSheet: {
      title: 'Yeniden bağla',
      conversation: 'Konuşma',
      search: 'Ara',
    },
    relinkDialog: {
      title: 'Satış yeniden bağlansın mı?',
      description: 'Satış {conversation} konuşmasına taşınır ve kesin olarak işaretlenir.',
    },
  },
  summary: {
    funnel: 'Satış hunisi',
    byChannel: 'Kanala göre',
    byLabel: 'Etikete göre',
    columns: {
      channel: 'Kanal',
      label: 'Etiket',
      count: 'Adet',
      amount: 'Tutar',
    },
    settings: {
      title: 'Atıf ayarları',
      window: 'Atıf penceresi (gün)',
      hint: 'Pencere, müşterinin son mesajından sonra bir siparişin bu konuşmaya sayılacağı süredir.',
      methods: 'Kullanılan yöntemler',
      method: {
        staff: 'Personel kaydı',
        identity: 'Kimlik eşleşmesi',
        link: 'Takipli bağlantı',
      },
      save: 'Kaydet',
    },
  },
} as const satisfies CatalogTree;
